export const SIDE_SHEET_PAGE_ID = 'pid';
